/**
 * Rental agreement record category values
 */
export enum RentalAgreementRecordCategoryEnum {
	VEHICLE = 'vehicle',
	VEHICLE_CATEGORY = 'vehicle_category',
}
